import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';

const POLL_MS = 60_000;

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

/**
 * Polls GET /api/notifications/unread-count every minute for the bell-icon
 * badge. Uses the dedicated count endpoint (a single COUNT) instead of
 * fetching rows. A fuller solution would use push / websockets.
 */
export function useUnreadNotifications() {
  const [count, setCount] = useState(0);
  const timerRef = useRef<number | null>(null);

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API_URL}/api/notifications/unread-count`, { headers: authHeaders() });
      const c = Number(r.data?.count);
      setCount(Number.isFinite(c) ? c : 0);
    } catch {
      /* silent */
    }
  }, []);

  useEffect(() => {
    refresh();
    timerRef.current = window.setInterval(refresh, POLL_MS);
    return () => { if (timerRef.current) window.clearInterval(timerRef.current); };
  }, [refresh]);

  return { count, refresh };
}
